import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GenKisiAramaService } from './ctl-gen-kisi-arama.service';
import { DxButtonModule, DxTextBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { debounceTime, Observable, Subject, Subscription } from 'rxjs';
import { GenKisiService } from '../ctl-gen-kisi.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {DlistDto} from "../../../../models/ortak.dtos";

@Component({
  selector: 'dk-ctl-gen-kisi-arama',
  templateUrl: './ctl-gen-kisi-arama.component.html',
  styleUrls: ['./ctl-gen-kisi-arama.component.scss'],
  standalone: true,
  imports: [DxButtonModule,DkDxDataCtlTableComponent,CommonModule,DxTextBoxModule],
  providers: [GenKisiAramaService],
})
export class CtlGenKisiAramaComponent implements OnInit, OnDestroy{
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @ViewChild(DxTextBoxComponent) searchInput!: DxTextBoxComponent;
  @Input() control: any;
  @Input() filterColumn: string;
  @Input() filterColumnValue: any;
  /** Hazır DevExtreme filtre ifadesi. Doluysa filterColumn/filterColumnValue yerine bu kullanılır. */
  @Input() filterExpression: any = null;
  @Input() filterArray: any[] = [];
  @Output() private closePopup = new EventEmitter<any>();
  public filterValue:any
  public searchValue: string= "";
  firstReadyCheck = true;
  private typingSubject: Subject<string> = new Subject();
  private subscription!: Subscription;
  constructor(
    private service: GenKisiAramaService,
    private genKisiService:GenKisiService,
    public ortakService:OrtakService
  ) {
  }

  ngOnInit(): void {
    this.subscription = this.typingSubject.pipe(
      debounceTime(1000)
    ).subscribe(value => {
      this.performSearch(value);
    });
    if(this.filterExpression){
      this.filterValue = this.filterExpression
    }
    else if(this.filterColumnValue){
      this.filterValue = [this.filterColumn, '=', this.filterColumnValue]
    }
    this.data = this.service.getData(this.control,this.filterArray);
    this.gridControlsList$ = this.genKisiService.gridControlsList$;
    this.genKisiService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

onContentReady(e: any) {
  if(this.firstReadyCheck){
    setTimeout(() => {
      this.searchInput.instance.focus();
      this.firstReadyCheck = false;
    }, 300);
  }
}

  onKeyInput(e: any) {
    const currentValue = e.event.target.value;
    this.typingSubject.next(currentValue);
  }

  performSearch(value: string) {
    this.data = this.service.getData(this.control,this.filterArray,value);
  }
  customSearch(e:any){
    this.data = this.service.getData(this.control,this.filterArray,e);
  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }
  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.resetFilter();
      this.closePopup.emit(this.selectedData);
    }
  }

  dblClickRow(e:any){
    this.resetFilter();
    this.closePopup.emit(e);
  }
  chooseBtnClick() {
    this.resetFilter();
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.resetFilter();
    this.closePopup.emit(null);
  }

  private resetFilter() {
    this.filterColumnValue = undefined;
    this.filterExpression = null;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
